"use client"

import clsx from "clsx"
import { motion } from "framer-motion"
import Image from "next/image"

const logos = [
  {
    src: "/static/images/ledger.svg",
    title: "Ledger",
    className: "h-6",
  },
  {
    src: "/static/images/layerzero.svg",
    title: "LayerZero",
    className: "h-7",
  },
  {
    src: "/static/images/swapkit.svg",
    title: "Swapkit",
    className: "h-5",
  },
  {
    src: "/static/images/rabby.svg",
    title: "Rabby",
    className: "h-6",
  },
  {
    src: "/static/images/solflare.svg",
    title: "Solflare",
    className: "h-5",
  },
  {
    src: "/static/images/zodl.svg",
    title: "Zodl",
    className: "h-5",
  },
] as const

const TICKER_DURATION_S = 28

function LogoItem({
  src,
  title,
  className,
  decorative = false,
}: {
  src: string
  title: string
  className: string
  decorative?: boolean
}) {
  return (
    <div className="flex h-8 shrink-0 items-center justify-center opacity-70">
      <Image
        src={src}
        alt={decorative ? "" : title}
        width={100}
        height={50}
        className={clsx(
          "w-auto max-w-none select-none object-contain",
          className
        )}
      />
    </div>
  )
}

export default function PartnerLogos() {
  return (
    <div className="border-white/11 border-b bg-gray-800">
      <div className="hidden items-center justify-between px-8 py-12 lg:flex">
        {logos.map((logo) => (
          <LogoItem key={logo.title} {...logo} />
        ))}
      </div>

      <div className="overflow-hidden py-12 lg:hidden">
        <motion.div
          className="flex w-max items-center"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            duration: TICKER_DURATION_S,
            ease: "linear",
            repeat: Number.POSITIVE_INFINITY,
          }}
        >
          {[0, 1].map((copy) => (
            <div
              key={copy}
              className="flex shrink-0 items-center gap-12 px-6 sm:gap-16 sm:px-8 md:gap-24 md:px-12"
              aria-hidden={copy === 1}
            >
              {logos.map((logo) => (
                <LogoItem
                  key={`${copy}-${logo.title}`}
                  {...logo}
                  decorative={copy === 1}
                />
              ))}
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  )
}
